import styled from "styled-components";

const StyledClassForm = styled.div`
    display: flex;
    justify-content: center;

.select-div select{
    width: 25rem;
}

.back-div {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

} 
`

export default StyledClassForm;